/**
 * Customer-number format helpers — thin aliases over the shared entity-number engine.
 * Existing imports stay valid.
 */
import {
  ENTITY_NUMBER_FORMAT_MAX_LEN,
  ENTITY_NUMBER_SEQ_DIGITS_MAX,
  ENTITY_NUMBER_SEQ_DIGITS_MIN,
  buildEntityNumberFormat,
  counterYearForFormat,
  entityNumberFormatUsesYear,
  isUniqueViolation,
  normalizeEntityNumberFormat,
  normalizeManualEntityNumber,
  parseEntityNumberFormatParts,
  parseSeqDigits,
  renderEntityNumber,
  type EntityNumberFormatParts,
  type EntityNumberFormatValidation,
  type EntityNumberYearMode,
  type ManualEntityNumberValidation,
} from './entityNumberFormat';

/** Default template — preserves historical `KND-YYYY-#####` allocation. */
export const DEFAULT_CUSTOMER_NUMBER_FORMAT = 'KND-{YEAR}-{SEQ:5}';

export const CUSTOMER_NUMBER_FORMAT_MAX_LEN = ENTITY_NUMBER_FORMAT_MAX_LEN;
export const CUSTOMER_NUMBER_SEQ_DIGITS_MIN = ENTITY_NUMBER_SEQ_DIGITS_MIN;
export const CUSTOMER_NUMBER_SEQ_DIGITS_MAX = ENTITY_NUMBER_SEQ_DIGITS_MAX;

export type CustomerNumberFormatValidation = EntityNumberFormatValidation;
export type ManualCustomerNumberValidation = ManualEntityNumberValidation;
export type CustomerNumberYearMode = EntityNumberYearMode;
export type CustomerNumberFormatParts = EntityNumberFormatParts;

export function normalizeCustomerNumberFormat(raw: unknown): CustomerNumberFormatValidation {
  return normalizeEntityNumberFormat(raw);
}

export function customerNumberFormatUsesYear(format: string): boolean {
  return entityNumberFormatUsesYear(format);
}

export { parseSeqDigits, counterYearForFormat, isUniqueViolation };

export function buildCustomerNumberFormat(parts: CustomerNumberFormatParts): string {
  return buildEntityNumberFormat(parts);
}

export function parseCustomerNumberFormatParts(format: string): CustomerNumberFormatParts {
  return parseEntityNumberFormatParts(format, DEFAULT_CUSTOMER_NUMBER_FORMAT);
}

export function renderCustomerNumber(
  format: string,
  seq: number,
  calendarYear: number = new Date().getFullYear(),
): string {
  return renderEntityNumber(format, seq, calendarYear);
}

export function normalizeManualCustomerNumber(raw: unknown): ManualCustomerNumberValidation {
  return normalizeManualEntityNumber(raw, 'Kundennummer');
}
